<template>
  <v-container fill-height fluid grid-list-xl>
    <v-form ref="form" v-model="validForm" class="ae_upsert" v-if="!loadError">
      <safety-ae-treatment-modal v-model="openTreatments" :sae="item" />
      <safety-meddra-modal v-model="openMeddra" :sae.sync="item" />
      <safety-causality-modal v-model="causalityModal" :sae.sync="item" />
      <safety-cin-modal v-model="chooseInitial" :title="chooseInitialTitle" :initialsList="initialsList"
        :choosed.sync="choosedInitial" />
      <safety-qualitycheck-modal v-model="qualitycheckModal" @input="save()" :itemEvent.sync="item" eventType="adverse_event" />
      <safety-pdf-preview-modal v-model="pdfPreview" :item="item" itemType="sae" />
      <safety-mmquery-modal v-model="openMMQuery" :itemEvent="item" eventType="adverse_event" />

      <v-layout justify-center wrap white>


        <v-flex xs12 sm12 md12>
          <v-subheader style="background-color:#306293;color:white;border-radius:5px">
            Case DESCRIPTION
          </v-subheader>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-text-field label="Case Identification Number" v-model="cin" disabled></v-text-field>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-select clearable md4 v-model="selectedProtocol" :items="protocols" label="Protocol"
            :rules="validators.sae.protocol" item-value="id" item-text="name" return-object :disabled="!isNew"
            @change="calculateCin(); searchCenter()" :readonly="!$can('upsert', 'adverse_event')"></v-select>
        </v-flex>


        <v-flex xs12 sm1 md1>
          <v-text-field label="Patient" :disabled="!isNew && !warningMode" v-model="item.patient_id"
            :rules="validators.sae.patient" @input="searchCenter()" @change="calculateCin()"
            :readonly="!$can('upsert', 'adverse_event')"></v-text-field>
        </v-flex>

        <v-flex xs12 sm3 md3>
          <v-autocomplete md4 clearable :search-input.sync="siteSearchString" v-model="selectedSite" :items="sites"
            color="primary" hide-no-data item-text="name" item-value="id" label="Site" return-object
            prepend-icon="mdi-database-search" :loading="loadingSites"
            :disabled="(!isNew && !warningMode) || !item.protocol_id" :rules="validators.sae.site"
            @change="calculateCin()" :readonly="!$can('upsert', 'adverse_event')">
            <template slot="item" slot-scope="{ item }">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.city }} ({{
                  item.country_code
                }})</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>


        <v-flex xs12 sm1 md1>
          <v-menu v-model="menu_datePicker_onset_date" :close-on-content-click="false" :nudge-right="40" lazy
            transition="scale-transition" offset-y full-width :disabled="!isNew && !warningMode"
            :readonly="!$can('upsert', 'adverse_event')">
            <template slot="activator">
              <v-text-field style="font-size:0.9em;min-width:100px" clearable v-model="item.ae_onset_date"
                @change="calculateCin()" label="AE Onset Date" readonly :rules="validators.sae.ae_onset_date"
                :disabled="!isNew && !warningMode"></v-text-field>
            </template>
            <v-date-picker dark v-model="item.ae_onset_date" no-title @input="menu_datePicker_onset_date = false"
              @change="calculateCin()" :disabled="!isNew && !warningMode"
              :readonly="!$can('upsert', 'adverse_event')"></v-date-picker>
          </v-menu>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-select clearable required label="Case Type" v-model="item.case_type" :rules="validators.sae.case_type"
            :items="['Initial', 'Follow up', 'Final']" :disabled="!isNew && !warningMode" @change="calculateCin()"
            :readonly="!$can('upsert', 'adverse_event')"></v-select>
        </v-flex>

        <v-flex xs12 sm1 md1>
          <v-menu v-model="menu_datePicker_receipt_date" :close-on-content-click="false" :nudge-right="40" lazy
            transition="scale-transition" offset-y full-width max-width="290px" min-width="290px"
            :disabled="item.status == 'Close'" :readonly="!$can('upsert', 'adverse_event')">
            <template slot="activator">
              <v-text-field clearable style="font-size:0.9em;min-width:100px" v-model="item.receipt_date"
                label="Receipt Date" :disabled="item.status == 'Close'" readonly
                :rules="validators.sae.receipt_date"></v-text-field>
            </template>
            <v-date-picker :disabled="item.status == 'Close'" dark v-model="item.receipt_date" no-title
              @input="menu_datePicker_receipt_date = false" :readonly="!$can('upsert', 'adverse_event')"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-select clearable md4 v-model="item.gender" :items="['Male', 'Female', 'Unknown', 'Undifferentiated']"
            label="Gender" :readonly="!$can('upsert', 'adverse_event')"></v-select>
        </v-flex>

        <v-flex xs12 sm1 md1>
          <v-text-field label="Year of birth" v-model="item.year_of_birth" @input="calculateAge" type="number"
            :readonly="!$can('upsert', 'adverse_event')"></v-text-field>
        </v-flex>

        <v-flex xs12 sm1 md1>
          <v-text-field label="Age" v-model="item.age" type="number" @change="calculateYearOfBirth()"
            :readonly="!$can('upsert', 'adverse_event')"
            @input="(age) => { age == '' ? item.age = null : age }"></v-text-field>
        </v-flex>

        <v-flex xs12 sm3 md3>
          <v-text-field label="AE Verbatim Reported" v-model="item.ae_verbatim_reported"
            :rules="validators.sae.ae_verbatim_reported" :readonly="!$can('upsert', 'adverse_event')"></v-text-field>
        </v-flex>

        <v-flex xs12 sm1 md1 class="text-xs-center">
          <v-tooltip top>
            <template slot="activator" slot-scope="{ on }">
              <v-btn v-on="item.meddra_pt_id ? on : {}" small
                :disabled="isNew || !$can('upsert', 'adverse_event') || item.status == 'Canceled'"
                @click="openMeddra = true" :color="item.meddra_pt_id ? 'green' : 'pink'">
                <v-icon small>mdi-database-search</v-icon> &nbsp;&nbsp; Meddra
              </v-btn>
            </template>
            <span>(PT){{ item.meddra_ae_preferred_term }}<br></span>
          </v-tooltip>
        </v-flex>

        <!--v-flex xs12 sm1 md1>
          <v-checkbox 
            label="Serious" 
            v-model="item.serious"
            v-bind:false-value="0"
            v-bind:true-value="1"
            :readonly="!$can('upsert', 'adverse_event')"
            ></v-checkbox>
        </v-flex-->

        <v-flex xs12 sm3 md3>
          <v-combobox style="padding-top:2px" multiple v-model="item.arms" :items="arms" label="Arms" append-icon chips
            deletable-chips class="tag-input" @keydown.space.prevent :readonly="!$can('upsert', 'adverse_event')">
          </v-combobox>
        </v-flex>


        <v-flex xs12 sm1 md1>
          <v-menu v-model="menu_datePicker_awareness_date" :close-on-content-click="false" :nudge-right="40" lazy
            transition="scale-transition" offset-y full-width max-width="290px" min-width="290px"
            :disabled="item.status == 'Close'" :readonly="!$can('upsert', 'adverse_event')">
            <template slot="activator">
              <v-text-field clearable style="font-size:0.9em;min-width:100px" v-model="item.awareness_date"
                label="Awareness Date" :disabled="item.status == 'Close'" readonly
                :_rules="validators.sae.awareness_date"></v-text-field>
            </template>
            <v-date-picker :disabled="item.status == 'Close'" dark v-model="item.awareness_date" no-title
              @input="menu_datePicker_awareness_date = false"
              :readonly="!$can('upsert', 'adverse_event')"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-combobox style="padding-top:2px" clearable md4 multiple chips :rules="validators.sae.serious_criteria"
            v-model="item.serious_criteria" :items="seriousCriterias" label="Serious Criteria"
            :readonly="!$can('upsert', 'adverse_event')"></v-combobox>
        </v-flex>

        <v-flex xs12 sm1 md1>
          <v-select label="CTCAE Grade" v-model="item.ctcae_grade" clearable
            :items="[{ id: 6, label: 'N/A' }, { id: 1, label: '1' }, { id: 2, label: '2' }, { id: 3, label: '3' }, { id: 4, label: '4' }, { id: 5, label: '5' },]"
            item-value="id" item-text="label" :readonly="!$can('upsert', 'adverse_event')"></v-select>
        </v-flex>

        <v-flex xs12 sm3 md3>
          <v-select label="Outcome" v-model="item.outcome" clearable :items="[
            'Recovered or Resolved',
            'Recovered or Resolved with Sequelae',
            'Recovering or Resolving',
            'Not recovered or Not resolved',
            'Not applicable',
            'Fatal',
            'Unknown'
          ]" :readonly="!$can('upsert', 'adverse_event')"></v-select>
        </v-flex>

        <v-flex xs12 sm1 md1>
          <v-menu v-model="menu_datePicker_end_date" :close-on-content-click="false" :nudge-right="40" lazy
            transition="scale-transition" offset-y full-width max-width="290px" min-width="290px"
            :readonly="!$can('upsert', 'adverse_event')">
            <template slot="activator">
              <v-text-field clearable style="font-size:0.9em;min-width:100px" v-model="item.ae_end_date"
                label="AE End Date" readonly></v-text-field>
            </template>
            <v-date-picker dark v-model="item.ae_end_date" no-title @input="menu_datePicker_end_date = false"
              :readonly="!$can('upsert', 'adverse_event')"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm1 md1>
          <v-menu v-model="menu_datePicker_date_of_death" :close-on-content-click="false" :nudge-right="40" lazy
            transition="scale-transition" offset-y full-width max-width="290px" min-width="290px"
            :readonly="!$can('upsert', 'adverse_event')">
            <template slot="activator">
              <v-text-field clearable style="font-size:0.9em;min-width:97px" v-model="item.date_of_death"
                label="Date of death" readonly></v-text-field>
            </template>
            <v-date-picker dark v-model="item.date_of_death" no-title @input="menu_datePicker_date_of_death = false"
              :readonly="!$can('upsert', 'adverse_event')"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-subheader style="background-color:#306293;color:white;border-radius:5px">
            Case TRIAGE
          </v-subheader>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-subheader style="background-color:#306293;color:white;border-radius:5px">
            Case ASSESSMENT
          </v-subheader>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-text-field label="Sponsor Triage" v-model="item.sponsor_triage"
            :readonly="!$can('upsert', 'adverse_event')"></v-text-field>
        </v-flex>

        <!-- //issue 679 -->
        <v-flex xs12 sm2 md2 v-show="false">
          <v-text-field label="qualitychecklastrow" v-model="item.qualitychecklastrow"></v-text-field>
        </v-flex>
        <!-- //issue 679 -->

        <v-flex xs12 sm2 md2>
          <v-menu v-model="menu_datePicker_sponsor_triage_date" :close-on-content-click="false" :nudge-right="40" lazy
            transition="scale-transition" offset-y full-width :readonly="!$can('upsert', 'adverse_event')">
            <template slot="activator">
              <v-text-field clearable v-model="item.sponsor_triage_date" label="Sponsor Triage Date"
                readonly></v-text-field>
            </template>
            <v-date-picker dark v-model="item.sponsor_triage_date" no-title
              @input="menu_datePicker_sponsor_triage_date = false"
              :readonly="!$can('upsert', 'adverse_event')"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-text-field label="CRO Triage" v-model="item.cro_triage"
            :readonly="!$can('upsert', 'adverse_event')"></v-text-field>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-select clearable md4 v-model="item.case_assessment" :items="['ae', 'sae', 'susar', 'sar', 'aesi']"
            label="Case Assessment" :readonly="!$can('upsert', 'adverse_event')"></v-select>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-menu v-model="menu_datePicker_case_assessment_date" :close-on-content-click="false" :nudge-right="40" lazy
            transition="scale-transition" offset-y full-width max-width="290px" min-width="290px"
            :readonly="!$can('upsert', 'adverse_event')">
            <template slot="activator">
              <v-text-field clearable v-model="item.case_assessment_date" label="Case Assessment Date"
                readonly></v-text-field>
            </template>
            <v-date-picker dark v-model="item.case_assessment_date" no-title
              @input="menu_datePicker_case_assessment_date = false"
              :readonly="!$can('upsert', 'adverse_event')"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-menu v-model="menu_datePicker_evctm_date" :close-on-content-click="false" :nudge-right="40" lazy
            transition="scale-transition" offset-y full-width max-width="290px" min-width="290px"
            :readonly="!$can('upsert', 'adverse_event')">
            <template slot="activator">
              <v-text-field clearable v-model="item.evctm_reporting_date" label="EVCTM Reporting Date"
                readonly></v-text-field>
            </template>
            <v-date-picker dark v-model="item.evctm_reporting_date" no-title @input="menu_datePicker_evctm_date = false"
              :readonly="!$can('upsert', 'adverse_event')"></v-date-picker>
          </v-menu>
        </v-flex>


        <v-flex xs12 sm6 md6>
          <v-textarea label="Comments" v-model="item.clinical_comments" rows="1" clearable
            :readonly="!$can('upsert', 'adverse_event')"></v-textarea>
        </v-flex>




        <!--v-flex xs12 sm4 md4>
          <v-textarea
            label="Triage Comments"
            v-model="item.triage_comments"
            rows="1"
            clearable
          ></v-textarea>
        </v-flex-->


        <v-flex xs12 sm2 md2>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-tooltip top close-delay='300' min-width='50px'>
            <template slot="activator" slot-scope="{ on }">
              <v-btn v-on="item.quality_check ? on : {}" class="mx-1 font-weight-light" small
                :disabled="isNew || !$can('upsert', 'adverse_event') || item.account.role == 'Guest' || item.account.role == 'Provider' || item.status == 'Canceled'"
                @click="qualitycheckModal = true" :color="qualitycheckColor">
                <v-icon small>mdi-check</v-icon> &nbsp;&nbsp; Quality Check
              </v-btn>
            </template>
            <span>{{ item.quality_check_date }}</span>
          </v-tooltip>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-tooltip top min-width='500px' :disabled="!item.errors">
            <template slot="activator" slot-scope="{ on }">
              <div v-on="on">

                <v-select clearable md4 v-model="item.status" :items="['Open', 'Close', 'Warning', 'Query', 'Canceled']"
                  label="Status" :disabled="warningMode && !cin" :readonly="!$can('upsert', 'adverse_event')"></v-select>


              </div>
            </template>
            <span>{{ item.errors }}</span>
          </v-tooltip>
        </v-flex>





        <v-flex xs12 sm8 md8>
          <br>
        </v-flex>



        <v-flex xs12 text-xs-right>


          <v-btn color="pink" dark class="mx-1 font-weight-light" small dense @click="$router.go(-1)">
            <v-icon small>mdi-arrow-left</v-icon>
          </v-btn>

          <v-tooltip top close-delay='2000' min-width='50px'>
            <template slot="activator" slot-scope="{ on }">
              <v-btn v-on="item.causality ? on : {}" class="mx-1 font-weight-light" small
                :disabled="isAdminOrEmployee ||isNew || item.status == 'Canceled'" @click="causalityModal = true" :color="causalityColor">
                <v-icon small>mdi-file-document-edit-outline</v-icon> &nbsp;&nbsp; Causality
              </v-btn>
            </template>
            <span><a @click="downloadCausalityPdf">PDF</a></span>
          </v-tooltip>



          <v-tooltip top close-delay='2000' min-width='350px' 
            v-if="$can('upsert', 'adverse_event') && $can('read', 'adverse_event') && item.pdf">
            <template slot="activator" slot-scope="{ on }" >
                <v-btn v-on="item.pdf ? on : {}" class="mx-1 font-weight-light" small
                    :disabled="isNew || !$can('upsert', 'adverse_event') || item.status == 'Canceled'"
                    @click="pickFile('sae')" :color="item.pdf ? 'green' : 'pink'">
                    <v-icon small>mdi-upload</v-icon> &nbsp;&nbsp; PDF
                    &nbsp;&nbsp;

                    <v-btn v-if="canRemovePdf" color="pink" class="remove-pdf" @click.stop="removePDF()">
                       X
                    </v-btn>
                  </v-btn> 
            </template>
            <span><a @click="downloadPdf">{{ item.pdf }}</a></span>
          </v-tooltip>
          <!-- Per evitare bug grafici dovuti al tooltip ho duplicato il bottone -->
          <v-btn v-else  v-on="item.pdf ? on : {}" class="mx-1 font-weight-light" small
                    :disabled="isNew || !$can('upsert', 'adverse_event') || item.status == 'Canceled'"
                    @click="pickFile('sae')" :color="'pink'">
                    <v-icon small>mdi-upload</v-icon> &nbsp;&nbsp; PDF
                    &nbsp;&nbsp;
          </v-btn> 
          
          <v-tooltip top close-delay='2000' min-width='350px'
            v-if="!$can('upsert', 'adverse_event') && $can('read', 'adverse_event')">
            <template slot="activator" slot-scope="{ on }">
              <v-btn v-on="item.pdf ? on : {}" class="mx-1 font-weight-light" small
                :disabled="isNew || !item.pdf || item.status == 'Canceled'" @click="downloadPdf"
                :color="item.pdf ? 'green' : 'pink'">
                <v-icon small>mdi-eye</v-icon> &nbsp;&nbsp; PDF
              </v-btn>
            </template>
            <span>{{ item.pdf }}</span>
          </v-tooltip>

          <v-tooltip top min-width='200px'>
            <template slot="activator" slot-scope="{ on }">
              <v-btn v-on="item.company_notification_date ? on : {}" class="mx-1 font-weight-light"
                :disabled="isNew || !item.pdf || !item.cin || warningMode || !$can('upsert', 'adverse_event') || item.status == 'Canceled'"
                @click="notifyCompany()" small :color="item.company_notification_date ? 'green' : 'pink'">
                <v-icon small>mdi-email-send</v-icon> &nbsp;&nbsp; Company</v-btn>
            </template>
            <span>Notified on {{ item.company_notification_date }}</span>
          </v-tooltip>


          <v-tooltip top min-width='200px'>
            <template slot="activator" slot-scope="{ on }">
              <v-btn v-on="item.medical_notification_date ? on : {}" class="mx-1 font-weight-light"
                :color="item.medical_notification_date ? 'green' : 'pink'"
                :disabled="isNew || !item.pdf || !item.cin || warningMode || !$can('upsert', 'adverse_event') || item.status == 'Canceled'"
                small @click="notifyMedicalMonitor()">
                <v-icon small>mdi-email-send</v-icon> &nbsp;&nbsp; Medical Monitor</v-btn>
            </template>
            <span>Notified on {{ item.medical_notification_date }}</span>
          </v-tooltip>


          <v-btn :disabled="isNew || !$can('upsert', 'mm_query') || item.status == 'Canceled'"
            class="mx-1 font-weight-light" color="success" small @click="openMMQuery = true"> <v-icon
              small>mdi-account-question</v-icon> &nbsp;&nbsp;MM Query</v-btn>

          <v-btn :disabled="isNew || !$can('read', 'adverse_event_has_treatment') || item.status == 'Canceled'"
            class="mx-1 font-weight-light" color="success" small @click="openTreatments = true"> <v-icon
              small>mdi-pill</v-icon> &nbsp;&nbsp;Treatments</v-btn>

          <v-btn class="mx-1 font-weight-light" color="purple" small
            :disabled="(!checkSave() && !validForm) || item.status == 'Canceled'" :loading="loadingSave"
            v-if="$can('upsert', 'adverse_event')" @click="save()">Save</v-btn>
        </v-flex>

        <!-- <v-flex xs12 v-if="$can('read', 'audittrail')">
          <safety-audittrail-timeline v-if="!isNew" entity="adverse_event" :entity_id="$route.params.id" />
        </v-flex> -->

        <input id="file" ref="file" type="file" style="display: none" accept=".pdf, application/pdf"
          @change="handleFileUpload()" />

      </v-layout>
    </v-form>


    <v-layout justify-center wrap white v-if="loadError">
      <v-flex xs12 sm12 md12>
        <v-alert type="warning" :value="true">
          ERROR Loading Adverse event record!
        </v-alert>
      </v-flex>
    </v-layout>


    <v-dialog v-model="notifyModal" persistent max-width="1100px">
      <material-card color="primary" :title="'Notify ' + notifyType + ' (' + item.cin + ')'">
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm12 md12>
                <v-autocomplete clearable md4 chips box multiple v-model="confirmed_emails_to_notify"
                  :items="emails_to_notify" label="Email Address">

                  <template slot="selection" slot-scope="data">
                    <v-chip :color="userTypeColor[data.item.type]" class="chip--select-multi">
                      {{ data.item.email }}
                    </v-chip>
                  </template>

                  <template slot="item" slot-scope="data">
                    <template v-if="!isObject(data.item)">
                      <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-action>
                        <v-checkbox v-model="confirmed_emails_to_notify.filter(s => s.email == data.item.email).length">
                        </v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="'(' + data.item.name + ') ' + data.item.email"> </v-list-tile-title>
                        <v-list-tile-sub-title :style="'color:' + userTypeColor[data.item.type]"
                          v-html="data.item.typeStr || data.item.type"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>

                </v-autocomplete>
              </v-flex>


              <v-flex xs12 sm12 md12>
                <v-text-field label="Email Subject" v-model="emailSubject" clearable></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-textarea label="Email Body" v-model="emailBody" rows="18" clearable
                  style="font-family:monospace"></v-textarea>
              </v-flex>


            </v-layout>
          </v-container>
        </v-form>

        <v-container grid-list-md>
          <v-layout wrap>

            <v-flex xs2 text-xs-left>

              <v-tooltip text-xs-left top close-delay='2000' min-width='350px' v-if="notifyType == 'Medical Monitor'">
                <template slot="activator" slot-scope="{ on }">
                  <v-btn v-on="item.medical_attachment ? on : {}" class="mx-1 font-weight-light" small
                    :disabled="isNew || !$can('upsert', 'adverse_event')" @click="pickFile('medical_monitor')"
                    :color="item.medical_attachment ? 'green' : 'pink'">
                    <v-icon small>mdi-upload</v-icon> &nbsp;&nbsp; Attachment
                  </v-btn>
                </template>
                <span><a @click="downloadMedicalMonitorAttachment">{{ item.medical_attachment }}</a></span>
              </v-tooltip>

            </v-flex>

            <v-flex xs10 text-xs-right>

              <v-btn class="mx-1 font-weight-light" small color="success"
                @click="notifyModal = false; emails_to_notify = confirmed_emails_to_notify = []">Close</v-btn>

              <v-btn small class="mx-1 font-weight-light" color="pink"
                :disabled="!confirmed_emails_to_notify.length || !$can('upsert', 'adverse_event')"
                @click="confirmNotify()">Notify now</v-btn>
            </v-flex>

          </v-layout>
        </v-container>
      </material-card>
    </v-dialog>


    <v-dialog v-model="anotherInitial" persistent max-width="800px">
      <material-card color="primary" title="Another SAE for the same AE Onset Date and Patient. Are you Sure?">
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>

                <v-data-table :items="[anotherInitialSae]" hide-actions>
                  <template slot="headers" slot-scope="props">
                    <tr>
                      <th class="text-xs-left">Cin</th>
                      <th class="text-xs-left">Onset Date</th>
                      <th class="text-xs-left">Receipt Date</th>
                      <th class="text-xs-left">Verbatim reported</th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="{ item }">
                    <td class="text-xs-left"><b>{{ item.cin }}</b></td>
                    <td class="text-xs-left">{{ item.ae_onset_date }}</td>
                    <td class="text-xs-left">{{ item.receipt_date }}</td>
                    <td class="text-xs-left">{{ item.ae_verbatim_reported }}</td>
                  </template>
                </v-data-table>

              </v-flex>
            </v-layout>
          </v-container>
        </v-form>

        <v-flex xs12 text-xs-right>
          <v-btn class="mx-1 font-weight-light" color="success" @click="anotherInitial = false">Close</v-btn>

          <v-btn class="mx-1 font-weight-light" color="pink"
            @click="choosedInitial = anotherInitialSae_nextCin; anotherInitial = false;">Confirm</v-btn>

        </v-flex>

      </material-card>
    </v-dialog>



  </v-container>
</template>

<script>
import { getList as getAEList, upsert, getDetail, getSeriousCriterias, uploadPdf, removePdf, downloadPdf, nextCin, notifyAE, updatePdfName, searchCausalityByCin, causalityPdf } from "@/api/adverse_event";
import validators from "@/utils/validators";
import { get } from "@/api/base_api";
import { getList as getProtocolSites } from "@/api/protocol_site";
import { getList as getExternalUser } from "@/api/external_user";
import { getCompanyUserByAE } from "@/api/company_user";
import { emailBody, emailSubject } from "@/utils/ae_mail";

export default {
  inheritAttrs: false,
  data() {
    return {
      item: { protocol: {} },
      validForm: true,
      validators,
      menu_datePicker_date_of_death: false,
      menu_datePicker_onset_date: false,
      menu_datePicker_end_date: false,
      menu_datePicker_receipt_date: false,
      menu_datePicker_evctm_date: false,
      menu_datePicker_sponsor_triage_date: false,
      menu_datePicker_case_assessment_date: false,
      menu_datePicker_awareness_date: false,
      siteSearchString: "",
      loadingSites: false,
      sites: [],
      loadingExtUser: false,
      external_users: [],
      openTreatments: false,
      openMMQuery: false,
      openMeddra: false,
      selectedSite: null,
      selectedProtocol: null,
      cin: null,
      pdf: null,
      notifyModal: false,
      emails_to_notify: [],
      confirmed_emails_to_notify: [],
      notifyType: null,
      emailBody: null,
      emailSubjectSend: null,
      chooseInitial: false,
      chooseInitialTitle: '',
      initialsList: [],
      choosedInitial: null,
      anotherInitial: false,
      anotherInitialSae: {},
      anotherInitialSae_nextCin: null,
      userTypeColor: {
        'Personnel': '#adcc46',
        'Medical monitor': '#ff9494',
        'Company user': '#f3ac33',
      },
      realStatus: null,
      causalityModal: false,
      qualitycheckModal: false,
      pdfPreview: false,
      uploadFileType: null,
      loadingSave: false,
      loadError: false
    };
  },
  created() {
    this.$store.dispatch("app/sponsorsDisabled", true);
  },
  mounted() {
    if (this.$route.params.id) {
      this.getData(this.$route.params.id);
    } else {
      this.item.serious = 1;
    }
  },
  watch: {
    siteSearchString(val, oldVal) {
      if (!val) {
        this.sites = [];
        return;
      }
      this.loadingSites = true;
      getProtocolSites({ "site.name": "%" + val + "%", "protocol_id": this.item.protocol_id }, { rowsPerPage: null }).then(data => {
        const sites = data.data.map(el => {
          return el['site'];
        });
        this.sites = sites;
        this.loadingSites = false;
      });
    },
    selectedSite(v) {
      if (v) {
        this.item.site_id = v.id;
      }
    },
    selectedProtocol(v) {
      if (v) {
        this.item.protocol_id = v.id;
      } else {
        this.sites = [];
        this.selectedSite = null;
        this.item.site_id = null;
        this.item.protocol_id = null;
      }
    },
    choosedInitial(v) {
      this.cin = v;
      this.item.cin = v;
    },
    cin(v) {
      // if (v && this.warningMode) {
      //   // this.item.status = 'Open';
      //   // this.saveAndUpdatePdf();
      // }
      //  if (!v && this.warningMode) {
      //   this.item.status = 'Warning';
      // }
    }
  },
  asyncComputed: {
    async causalityColor() {

      if (this.item.causality) {
        return 'green';
      }

      const ret = await searchCausalityByCin(this.item.id)

      if (ret.status == 'exists') {
        return 'orange'
      }

      return 'pink'

    },
    async qualitycheckColor() {

      if (this.item.quality_check) {
        return 'green';
      }

      return 'pink'

    },
    async protocols() {
      if(this.isNew) {
        return this.$store.getters.protocols
      }
      const allProtocols = await get('/protocol', {'sponsor_id': this.item.protocol.sponsor_id}, {"rowsPerPage":null,"sortBy":"name","descending":false})
      return allProtocols.data;
    }

  },
  computed: {
    canRemovePdf(){
      return ['Administrator','Employee'].includes(this.$store.getters.userObj.role ) && this.item.pdf ? true : false
    },
    isAdminOrEmployee(){
      return !['Administrator','Employee'].includes(this.$store.getters.userObj.role )
    },
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New Adverse Event" : "Edit Adverse Event";
    },
    seriousCriterias() {
      return getSeriousCriterias();
    },
    arms() {
      if (!this.item.protocol_id)
        return []
      const currentProtocol = this.protocols.filter(el => {
        return el.id == this.item.protocol_id
      })[0];

      if (!currentProtocol)
        return []

      return [
        ...(currentProtocol.arms_r1 || []),
        ...(currentProtocol.arms_r2 || []),
        ...(currentProtocol.arms_r3 || []),
        ...(currentProtocol.arms_r4 || [])] || [];
    },

    emailSubject: {
      get() {
        const def = emailSubject(this.item, this.notifyType);
        this.emailSubjectSend = def;
        return def;
      },
      set(v) {
        this.emailSubjectSend = v;
      }
    },
    warningMode() {
      return this.realStatus == 'Warning';
    },

  },
  methods: {
    removePDF(){
      this.$store.dispatch("app/startLoading");
      removePdf(this.item.id)
      .then((data)=>{
        if(data){
          this.$store.dispatch("app/stopLoading");
          this.item.pdf=''
        }
      })
      .catch(() => {
        this.$store.dispatch("app/openSnackbar", {
          message:
            "An Error occurred during pdf delete " +
            e.response.data.message,
          color: "error"
        });
        this.$store.dispatch("app/stopLoading");
      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    getData(id) {

      getDetail(id)
        .then(data => {
          this.realStatus = data.status;
          this.item = data;
          this.cin = this.item.cin;
          this.sites = [this.item.site];
          this.selectedSite = this.item.site;
          this.selectedProtocol = this.item.protocol;
          this.$store.commit("app/adverseEventItem", data);
          this.$store.dispatch("app/loadSponsors");

          this.$store.dispatch("app/setSponsor", data.protocol.sponsor_id);

          if (!this.item.cin) {
            this.calculateCin();
          }
          this.loadError = false
        })
        .catch(e => {
          this.loadError = true
        });

    },
    calculateCin() {
      this.choosedInitial = null;
      if (
        (this.isNew || this.warningMode) &&
        this.selectedSite &&
        this.selectedProtocol &&
        this.item.patient_id &&
        this.item.ae_onset_date &&
        this.item.case_type
      ) {

        const nextCinData = {
          country_code: this.selectedSite.country_code,
          protocol_id: this.selectedProtocol.id,
          patient_id: this.item.patient_id,
          case_type: this.item.case_type,
          ae_onset_date: this.item.ae_onset_date,
          current_id: this.item.id
        };

        return nextCin(nextCinData).then((data) => {
          this.cin = this.item.cin = data.nextCIN;

          if (!this.isNew) {
            this.$store.dispatch("app/openSnackbar", {
              message: "CIN is changed, please check and save if it's correct",
              color: "warning"
            });
          }

          return data.nextCIN;
        }).catch(e => {

          this.cin = this.item.cin = null;

          const errorData = e.response.data;

          // choose initial for this follow up
          if (errorData.error_details && errorData.error_details.errorCode == 'multiple_initials') {
            this.initialsList = errorData.error_details.initials;
            this.chooseInitialTitle = "Multiple Initial case found for this SAE";
            this.chooseInitial = true;
            return null;
          }

          // confirm double initial for the same date
          if (errorData.error_details && errorData.error_details.errorCode == 'another_initial') {
            this.anotherInitialSae = errorData.error_details.initial;
            this.anotherInitialSae_nextCin = errorData.error_details.nextCin;
            this.anotherInitial = true;
            return null;
          }

          // no initial found...possibly onset date error
          if (errorData.error_details && errorData.error_details.errorCode == 'no_initial' && errorData.error_details.initials.length) {
            this.initialsList = errorData.error_details.initials;
            this.chooseInitialTitle = "No Initial case found for this SAE. OnSet Date is changed?";
            this.chooseInitial = true;
            return null;
          }


          this.$store.dispatch("app/openSnackbar", {
            message: "CIN error, please check data : " + errorData.message,
            color: "error"
          });
          return null

        });
      } else {
        this.cin = this.isNew ? null : this.item.cin;
      }

    },
    calculateAge(year) {
      // if(year == '') {
      //   this.item.year_of_birth = null
      // }
      // let age = new Date().getFullYear() - this.item.year_of_birth;
      // this.item.age = null;
      // if (age > 10 && age < 100) {
      //   this.item.age = age;
      // }
    },
    calculateYearOfBirth() {
      // const currentYear = new Date().getFullYear();
      // let yob = currentYear - this.item.age;
      // // this.item.year_of_birth = null;
      // if (yob > 1900 && yob < currentYear - 10) {

      //   if (this.item.year_of_birth == undefined || this.item.year_of_birth == '' || this.item.year_of_birth == null ) {
      //     this.item.year_of_birth = yob;
      //     return;
      //   }

      //   if (Math.abs(this.item.year_of_birth - yob) > 2) {
      //     this.item.year_of_birth = yob;
      //   }

      // }

    },
    checkSave() {
      return !this.isNew;
    },
    customArmTxt(arm) {
      return arm.rnd + ' - ' + arm.key;
    },
    customArmValue(arm) {
      return arm.key;
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      this.loadingSave = true

      this.realStatus = null

      delete this.item.quality_check
      delete this.item.quality_check_date

      this.item.mm_changed = 0

      upsert(this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: this.isNew ? "Adverse Event created correctly" : "Adverse Event updated correctly",
            color: "success"
          });

          const newItem = data.data

          // const newItem = JSON.parse(
          //   JSON.stringify(data.data).replace('""', /null/i)
          // );

          // this.item = data.data; // per poter fare questo bisogna aggiornare Beest 
          // e far in modo che post e put di una entity ritorni anche gli oggetti foreign
          // this.$store.commit("app/adverseEventItem", newItem);
          // this.$root.$emit("updateAdverseEvents", newItem);

          //issue 679
          //updatePdfName(newItem.id).then(data => {
          //  this.getData(newItem.id)
          //})
          //issue 679

        })
        .catch(e => {

          console.log("ERROR", e)
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Adverse Event update. ", // + e.response.data.message,
            color: "error"
          })
        })
        .finally(() => {
          this.loadingSave = false
        })
    },
    // saveAndUpdatePdf() {
    //   upsert(this.item).then(data => {
    //     updatePdfName(this.item.id).then( data => {
    //       this.item.pdf = data.pdf;
    //       this.realStatus = this.item.status;
    //     });
    //   });
    // },
    notifyCompany() {

      // get company users
      getCompanyUserByAE(
        { sae: this.item }
      ).then(cue => {
        const cueel = cue.map(el => {
          el['type'] = 'Company user';
          el['typeStr'] = 'Company user (' + el.company.name + ')';
          return el;
        });
        // get external user (Personnel)
        getExternalUser(
          { protocol_id: this.item.protocol_id, type: 'Personnel' },
          { rowsPerPage: null }
        ).then(etn => {
          // const etn = data.data.map( el => {return el.email; });
          this.emails_to_notify = this.confirmed_emails_to_notify = [...cueel, ...etn.data];//[...new Set(cue), ...new Set(etn)];
        });

      });

      this.notifyType = 'Company'

      const def = emailBody(this.item, this.notifyType)
      this.emailBody = def

      this.notifyModal = true
    },
    async notifyMedicalMonitor() {

      getExternalUser(
        { protocol_id: this.item.protocol_id, type: 'Medical Monitor' },
        { rowsPerPage: null }
      ).then(etn => {
        // const etn = data.data.map( el => {return el.email; });
        this.emails_to_notify = this.confirmed_emails_to_notify = etn.data;//[...new Set(etn)];
      })

      this.notifyType = 'Medical Monitor'

      const data = await get('/ae/lastSentMMAssessment/' + this.item.id)
      const treatments = data.tot ? data.data : []
      const def = emailBody(this.item, this.notifyType, treatments)
      this.emailBody = def

      this.notifyModal = true
    },
    confirmNotify() {

      this.loadingSave = true

      const notifyParams = {
        id: this.item.id,
        type: this.notifyType,
        emailSubject: this.emailSubjectSend,
        emailBody: this.emailBody,
        to: this.confirmed_emails_to_notify
      };

      notifyAE(notifyParams).then(data => {

        this.$store.dispatch("app/openSnackbar", {
          message: "Adverse Event correctly notified to " + this.notifyType,
          color: "success"
        });

        // if(this.notifyType == 'Medical Monitor') {
        //   this.item.mm_notified = 1
        //   upsert(this.item)
        // }

        if (data.company_notification_date) {
          this.item.company_notification_date = data.company_notification_date;
        }

        if (data.medical_notification_date) {
          this.item.medical_notification_date = data.medical_notification_date;
        }

      }).catch(e => {
        this.$store.dispatch("app/openSnackbar", {
          message:
            "An Error occurred during the Adverse Event " + this.notifyType + " notify. " +
            e.response.data.message,
          color: "error"
        });
      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
        this.loadingSave = false
      });

      this.notifyModal = false;
      this.$store.dispatch("app/startLoading");

    },
    pickFile(type) {
      this.uploadFileType = type
      this.$refs.file.click();
    },
    handleFileUpload(event) {

      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      this.$store.dispatch("app/startLoading");
      let formData = new FormData();
      formData.append('file', file);
      formData.append('id', this.item.id);
      formData.append('uploadType', this.uploadFileType);

      uploadPdf(formData).then(data => {
        this.$store.dispatch("app/stopLoading");
        if (this.uploadFileType == 'sae') {
          this.item.pdf = data.pdf;
          //ISSUE 648
          this.save();
          //ISSUE 648

          //issue 679
          updatePdfName(newItem.id).then(data => {
            this.getData(newItem.id)
          })
          //issue 679

        }
        if (this.uploadFileType == 'medical_monitor') {
          this.item.medical_attachment = data.pdf
        }
      }).catch(() => {
        this.$store.dispatch("app/openSnackbar", {
          message:
            "An Error occurred during pdf upload " +
            e.response.data.message,
          color: "error"
        });
        this.$store.dispatch("app/stopLoading");
      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
      this.$refs.file.value = '';
    },
    downloadPdf() {

      this.pdfPreview = true

      // this.$store.dispatch("app/startLoading");
      // downloadPdf(this.item.id, this.item.pdf).then( d => {
      //   this.$store.dispatch("app/stopLoading");
      // }).catch( e => {
      //    this.$store.dispatch("app/openSnackbar", {
      //       message: "An Error occurred during pdf download : " + (e.response.data.message || e.response.statusText),
      //       color: "error"
      //     });
      //    this.$store.dispatch("app/stopLoading");
      // });
    },
    downloadCausalityPdf() {

      causalityPdf(this.item.id).then(data => {
        this.$store.dispatch("app/openSnackbar", {
          message: "Causality PDF downloaded correctly",
          color: "success"
        });
      }).catch(e => {
        this.$store.dispatch("app/openSnackbar", {
          message:
            "An Error occurred during the Causality PDF creation : " + e.response.data.message,
          color: "error"
        });
      })

    },
    searchCenter() {
      if (this.selectedProtocol && this.item.patient_id) {
        getAEList({ protocol_id: this.selectedProtocol.id, patient_id: this.item.patient_id }, { rowsPerPage: null }).then(data => {
          if (data.tot > 0) {
            this.sites = [data.data[0].site];
            this.selectedSite = data.data[0].site;
          } else {
            this.selectedSite = {}
          }
        });
      }
    },
    isObject(v) {
      return typeof v == 'object'
    },
    downloadMedicalMonitorAttachment() {

      this.$store.dispatch("app/startLoading");
      downloadPdf(this.item.id, 'medical_monitor', this.item.medical_attachment).then(d => {
        this.$store.dispatch("app/stopLoading");
      }).catch(e => {
        this.$store.dispatch("app/openSnackbar", {
          message: "An Error occurred during pdf download : " + (e.response.data.message || e.response.statusText),
          color: "error"
        });
        this.$store.dispatch("app/stopLoading");
      });
    }

  }
};
</script>

<style>

.remove-pdf{
  margin: 0;
  padding: 0; 
  min-width: 30%;
  min-height: 0;
}

#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}

/* 
.ae_upsert .v-select__selection--comma {
  max-width: 200px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
} */
</style>

